export const apiEndpoint = {
    signUp: "signup",
    signIn: "signin",
    forgotPassword: "forgotPassword",
    updateForgotPassword: "updateForgotPassword",
    verifyOtp: "verifyOtp",
    signupwithemail: "signupwithemail",
    searchExistingValues: "searchExistingValues",
    checkEmail : "checkEmail",
    resendOtpCode : "/resendOtpCode",
}